module.exports = __webpack_public_path__ + "img/text2.b506fae4.png";